import { format } from 'date-fns';
import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { AscendState } from '../../ducks';
import { MxAccount } from '../../models/mx';
import AddTransactionForm, { AddTransactionFormValues } from './AddTransactionForm';
import { ADD_TRANSACTION } from '../../ducks/actions';
import { dateFormats } from '../../ducks/util';

type StateProps = {
  accounts: MxAccount[];
};
type DispatchProps = {
  submitAddTransaction: (data: {
    accountGuid: string;
    amount: number;
    date: string;
    description: string;
    topLevelCategory: string;
    transactionType: string;
  }) => void;
};
type OwnProps = {
  onClose: () => void;
};
type AddTransactionDialogProps = StateProps & DispatchProps & OwnProps;

const AddTransactionDialog = ({
  accounts,
  onClose,
  submitAddTransaction,
}: AddTransactionDialogProps) => {
  return (
    <AddTransactionForm
      accounts={accounts}
      onClose={onClose}
      onSubmit={(data: AddTransactionFormValues) =>
        submitAddTransaction({
          accountGuid: data.account,
          amount: data.amount,
          date: format(data.date, dateFormats.yearMonthDay),
          description: data.description,
          topLevelCategory: data.topLevelCategory,
          transactionType: data.type,
        })
      }
    />
  );
};

const mapStateToProps = (state: AscendState) => ({
  accounts: state.mx.accounts.data,
});

// noinspection JSUnusedGlobalSymbols
const mapDispatchToProps = (dispatch: Dispatch) => ({
  submitAddTransaction: (data: {
    accountGuid: string;
    amount: number;
    date: string;
    description: string;
    topLevelCategory: string;
    transactionType: string;
  }) => dispatch({ type: ADD_TRANSACTION, ...data }),
});

export default connect<StateProps, DispatchProps, OwnProps>(
  mapStateToProps,
  mapDispatchToProps
)(AddTransactionDialog);
